import Axios from "axios";

export function sendForDigitalSignature(encounterId, customerId, pdfToPrint, fileName, mode, emailId, phoneNumber) {
    return Axios.put(`api/pdf/customers/${customerId}/encounter/${encounterId}/${pdfToPrint}/signature/${mode}`, {
        emailAddress: emailId,
        phoneNumber: phoneNumber,
    });
}

export function sendForDigitalSignatureMulti(encounterId, customerId, pdfsToPrint, mode, emailId, phoneNumber) {
    return Axios.put(`api/pdf/customers/${customerId}/encounter/${encounterId}/signature/${mode}`, {
        alternateContactDetails: {
            emailAddress: emailId,
            phoneNumber: phoneNumber,
        },
        pdfTemplate: pdfsToPrint,
    });
}
